import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useSignOut, useSignIn } from "react-auth-kit";
import {
  sendApiRequest,
  createScrollQueryString,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import { Table, Icon, Alert } from "design-react-kit";

import secureLocalStorage from "react-secure-storage";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import PaginationControls from "../PaginationControls";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 250];

const AIFlowNotificationsTable = ({ columns, setIsLoading, isLoading }) => {
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortColumn, setSortColumn] = useState("importDate");
  const [isAscending, setIsAscending] = useState(false);
  const [searchText, setSearchText] = useState("");

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const params = useParams();
  const flowId = params?.flowId;

  const getReadyFlowNotifications = (page = currentPage, size = pageSize) => {
    setIsLoading(true);
    setError(null);
    sendApiRequest(
      "Flow/GetReadyFlowNotifications",
      "GET",
      true,
      {
        flowId,
        searchText,
        sortColumn,
        isAscending,
        skip: (page - 1) * size,
        take: size,
      },
      signIn,
      signOut,
      navigate,
      createScrollQueryString,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          if (
            response.errors[0] ===
            "Classificazione flusso notifiche non trovata"
          ) {
            navigate(-1);
            setIsLoading(false);
          } else {
            setError(response.errors);
            setIsLoading(false);
          }
        } else {
          setResults(response.data.notifications);
          setTotalCount(response.data.totalCount);
          setIsLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setCurrentPage(1);
      getReadyFlowNotifications(1, pageSize);
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortColumn, isAscending, searchText]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getReadyFlowNotifications(page, pageSize);
  };

  const handlePageSizeChange = (size) => {
    setCurrentPage(1);
    setPageSize(size);
    getReadyFlowNotifications(1, size);
  };

  const sortDataFromApi = (e, column, isAscending) => {
    const icons = document.querySelectorAll(".sort");
    icons.forEach((icon) => icon.setAttribute("fill", "#dadce0"));
    const target = e.target.closest("svg");
    target.setAttribute("fill", "#000");
    target.addEventListener("click", emptyReturn);
    setSortColumn(column);
    setIsAscending(isAscending);
    setResults(null);
  };

  const emptyReturn = (e) => {
    return;
  };

  function handleSearch(e) {
    setResults(null);
    setSearchText(e.target.value);
  }

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch filterHandler={handleSearch} text={"Cerca"} />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getReadyFlowNotifications()}
            />
          </span>
        </div>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {!isLoading && (
          <Table responsive className="table">
            <TableHeader columns={columns} sortFunction={sortDataFromApi} />
            <tbody>
              {results !== null &&
                results !== undefined &&
                results.map((result) => {
                  return (
                    <tr key={result.id}>
                      <td className="dataAcquisizione text-center">
                        {result.importDate}
                      </td>
                      <td className="notifica">{result.notificationName}</td>
                      <td className="client text-center">
                        {result.clientName}
                      </td>
                      <td className="text-center details">
                        <Icon
                          icon="it-password-visible"
                          fill="#06c"
                          role="button"
                          onClick={(e) => {
                            secureLocalStorage.setItem(
                              "notificationDescription",
                              result.notificationName
                            );
                            secureLocalStorage.setItem("edit", null);
                            navigate(
                              `/notificheAI/verification/edit/${result.id}`
                            );
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              {results !== null && results.length === 0 && (
                <tr>
                  <td colSpan={12}>
                    <Alert className="w-50 mx-auto" color="info">
                      Nessun risultato trovato!
                    </Alert>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
        {!isLoading && (
          <PaginationControls
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={pageSize}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        )}
      </div>
    </Fragment>
  );
};

export default AIFlowNotificationsTable;
